/**
 * Created by Jew on 7/24/2017.
 */
import {Component, ElementRef, HostListener, OnInit, OnDestroy, Renderer2, ViewChild} from '@angular/core';
import {DocListComponent} from 'app/dms/doclist/doclist.component';
import {IdexService} from 'app/idex.service';
import {UploadService} from 'app/dms/upload.service';
import {Router, ActivatedRoute} from '@angular/router';
import {CreateGoogleDriveComponent} from 'app/dms/google-drive/create-google-drive.component';
import {CreateOneDriveComponent} from 'app/dms/onedrive/create-onedrive.component';
import {CreateFolderComponent} from 'app/dms/create-folder/create-folder.component';
import {UploadFilesComponent} from 'app/dms/upload-files/upload-files.component';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {CorporateMemberComponent} from '../corporate-member/member.component';
import {TranslateService} from '@ngx-translate/core';
import {Path} from 'app/shared/path';
import {Subscription} from 'rxjs';
import {Toast} from 'app/shared/toast/toast';
import {AppComponent} from 'app/app.component';
import {DownloadZipComponent} from '../download-zip/download-zip.component';
import {MoveDialogComponent} from '../move/move.component';
import {ConfirmDeleteComponent} from '../confirm-delete/confirm-delete.component';
import {FileSizePipe} from '../../shared/file-size.pipe';
import {FileUploader} from '../file-uploader';
import {UploadProgressComponent} from '../upload-progress/upload-progress.component';
import {FormListDialogComponent} from '../../e-form/form-list-dialog/form-list-dialog.component';
import {EformAPI} from "../../e-form/e-form.api";
import {PdfTemplateListDialogComponent} from "../../admin/pdf-template-list-dialog/pdf-template-list-dialog.component";

@Component({
   selector: 'app-corporate',
   templateUrl: './corporate.component.html',
   styleUrls: ['./corporate.component.css']
})
export class CorporateComponent implements OnInit, OnDestroy {
   @ViewChild(DocListComponent, { static: true })
   public docList: DocListComponent;
   @ViewChild('fileUpload') fileUpload: any;
   @ViewChild('progress') progress: UploadProgressComponent;
   public tin: string;
   private path: string;
   paths: any[];
   private page = 1;
   private size = 50;
   user: any;
   errorMessage: string;
   doc: any;
   object_file: any[] = [];
   typeIsFolder = false;
   user_role: any;
   status: any;
   selectedItems: any[] = [];
   permisionMove = true;
   permisionDel = true;
   permisionDup = true;
   private routeSubscription: Subscription;
   private progress_dlg: MatDialogRef<UploadFilesComponent>;
   private memberDialog: MatDialogRef<CorporateMemberComponent>;
   private movedialog: MatDialogRef<MoveDialogComponent>;
   private formListDialog: MatDialogRef<FormListDialogComponent>;
   private pdfTemplateListDialog: MatDialogRef<PdfTemplateListDialogComponent>;
   @ViewChild('toolbar') toolbar: ElementRef;
   supportFolderUpload: boolean;
   annotationObj: any;
   private uploadCallback = {
      init: (files) => {
         this.progress.init(files);
      },
      quotaExceed: (i: number, size: number, error: string) => {
         this.progress.quotaExceed(i, size, error);
      },
      limitExceed: (i: number, size: number) => {
         this.progress.limitExceed(i, size, this.upload.limit);
      },
      progress: (i: number, progress: number) => {
         this.progress.update(i, progress);
      },
      cancelUpload: (i: number, error: string) => {
         this.progress.cancelUpload(i, error);
      },
      complete: () => {
         this.progress.complete();
         setTimeout(() => {
            this.progress.hide();
            this.docList.saveDoc(this.annotationObj);
            this.showDocument();
         }, this.progress.calcDelay());
      }
   };
   private itemDocument = {
      id: '',
      item: [],
   };

   constructor(private service: IdexService,
               private upload: UploadService,
               private router: Router,
               private renderer: Renderer2,
               private route: ActivatedRoute,
               private translate: TranslateService,
               public dialog: MatDialog,
               private toast: Toast,
               private fileSize: FileSizePipe,
               public uploader: FileUploader,
               private app: AppComponent,
               private eformAPI: EformAPI) {
      this.user = this.service.user;
   }

   ngOnInit(): void {
      sessionStorage.removeItem('shared');
      this.routeSubscription = this.route.url.subscribe(url => {
         if (url.length === 0) {
            this.router.navigate(['/files']);
            return;
         }
         this.tin = url.shift().toString();
         this.path = decodeURIComponent(url.join('/'));
         this.paths = this.createBreadcrumb();
         this.showDocument();
         this.upload.getLimitSize();
         for (const b of this.user.business) {
            if (b.tin === this.tin) {
               this.user_role = b.role;
               this.status = b.status;
            }
         }
         this.service.role = this.user_role;
         this.docList.items = undefined;
         this.docList.info = undefined;
      });
      const input = document.createElement('input');
      this.supportFolderUpload = ('webkitdirectory' in input
         || 'mozdirectory' in input
         || 'odirectory' in input
         || 'msdirectory' in input
         || 'directory' in input);
   }

   ngOnDestroy(): void {
      this.routeSubscription.unsubscribe();
   }

   @HostListener('window:scroll')
   scrollFixed() {
      this.toolbar.nativeElement.style.left = (240 - window.scrollX) + 'px';
   }

   private createBreadcrumb(): any[] {
      let business_name: string;
      for (const b of this.user.business) {
         if (b.tin === this.tin) {
            business_name = b.name;
            break;
         }
      }
      if (this.path.length === 0) {
         this.docList.paths = [{name: business_name}];
         return [{name: business_name}];
      }

      const paths = [];
      paths.push({name: business_name});

      let fullPath = '';
      const array = this.path.match(/[^/]+/g);
      for (let i = 0; i < array.length; i++) {
         if (i === array.length - 1) {
            fullPath = null;
         } else {
            if (fullPath.length > 0) {
               fullPath += '/';
            }
            fullPath += array[i];
         }
         paths.push({name: array[i], path: fullPath});
      }
      this.docList.paths = paths;
      return paths;
   }

   onClickItem(item: any) {
      let path = location.pathname;
      const idex = '/idex';
      if (path.startsWith(idex)) {
         path = path.substring(idex.length);
      }

      this.docList.corporatePath = path;
      localStorage.setItem('url', Path.combine(path));
      if (item.isFolder) {
         const url = Path.combine('/work', this.tin, encodeURIComponent(this.path), encodeURIComponent(item.name));
         this.router.navigate([url]);
      } else {
         const getType = item.name.substring(item.name.lastIndexOf(".") + 1, item.name.length);
         if (getType !== 'zdox') {
            this.router.navigate(['/file', item.id]);
         } else {
            localStorage.setItem('filename',item.name);
            localStorage.setItem('callback-url', this.router.url);
            localStorage.setItem('form-type', 'view');
            localStorage.setItem('form-path', this.path);
            this.router.navigate(['/eform/create/docId/' + item.id], {state: {docStatus: item.statusDocument}});
         }
      }
   }

   showDocument() {
      this.selectedItems = [];
      if (this.path) {
         this.docList.loadPathInfo(this.path, this.tin);
      }

      this.page = 1;
      this.service.listDocuments_business(this.path, this.page, this.size, this.tin)
         .subscribe(data => {
               this.docList.setItems(data.items, data.hasMore, data.metadata);
            },
            error => {
               this.errorMessage = error;
               if (error.status === 404) {
                  if (this.path) {
                     const url = Path.combine('/work', this.tin);
                     this.router.navigate([url]);
                  } else {
                     this.router.navigate(['/files']);
                  }
               }
            }
         );
   }

   onLoadMore() {
      this.service.listDocuments_business(this.path, this.page + 1, this.size, this.tin)
         .subscribe(
            data => {
               this.docList.addItems(data.items, data.hasMore);
               if (data.hasMore) {
                  this.page++;
               }
            });
   }

   navigate(path: string) {
      this.doc = undefined;
      let url = Path.combine('/work', this.tin);
      if (path) {
         url = Path.combine('/work', this.tin, encodeURIComponent(path));
         this.docList.corporatePath = path;
      } else {
         this.docList.corporatePath = 'rootPath';
      }
      this.router.navigate([url]);
   }

   setting(button: any) {
      const url = Path.combine('/company', encodeURIComponent(this.paths[0].name));
      this.router.navigate([url]);
   }

   newMember() {
      this.memberDialog = this.dialog.open(CorporateMemberComponent, {
         disableClose: true,
         data: this,
         width: '900px'
      });
      this.memberDialog.componentInstance.tin_id = this.tin;
      this.memberDialog.componentInstance.user_role = this.user_role;
      this.memberDialog.componentInstance.translate = this.translate;
   }

   // onSelectFiles(input: any) {
   //    if (input.files.length === 0) { return; }
   //    for (let i = 0; i < input.files.length; i++) {
   //       if (input.files[i].size > this.limitSize) {
   //          this.translate.get('uploadDoc.errorFileSize').subscribe(s => {
   //             this.toast.error(s);
   //          });
   //          return;
   //       }
   //    }
   //
   //    const files = input.files;
   //    // this.object_file = files;
   //    if (!this.app.uploading) {
   //       this.progress_dlg = this.dialog.open(UploadFilesComponent, {
   //          disableClose: true,
   //          data: this,
   //          hasBackdrop: false
   //       });
   //    }
   //    this.progress_dlg.updatePosition({ bottom: '10px', right: '10px' });
   //    this.progress_dlg.componentInstance.object_file = this.object_file;
   //    this.app.uploading = true;
   //    for (let i = 0; i < files.length; i++) {
   //       this.upload.getKeyUpload()
   //          .subscribe(data => {
   //             // this.object_file[i].key = data.key;
   //             // this.object_file[i].cancel = false;
   //             // this.object_file[i].mimeType = this.object_file[i].type;
   //             files[i].key = data.key;
   //             files[i].cancel = false;
   //             files[i].mimeType = files[i].type;
   //             this.upload.uploadFile(files[i], this.path, this, data.key, i, files.length);
   //          }, error => {
   //             this.progress_dlg.close();
   //          });
   //    }
   //    Array.from(input.files).forEach(file => {
   //       this.object_file.push(file);
   //    });
   // }

   onProgressLoad2(percen: any, count: any, file: any): void {
      file.percentage = percen;
      if (!file.close) {
         this.progress_dlg.componentInstance.progressBar_percentage(percen, count);
      }

   }

   successUpload1(ans: any): void {
      setTimeout(() => {
         if (ans === this.object_file.length) {
            this.progress_dlg.close();
            this.upload.sum_count = 0;
            this.fileUpload.nativeElement.value = '';
            this.showDocument();
            this.app.uploading = false;
            this.object_file = [];
         }
      }, 1000);
   }

   newFolder() {
      const dialogRef = this.dialog.open(CreateFolderComponent, {
         disableClose: true,
         data: this
      });
      dialogRef.componentInstance.toast = this.toast;
      dialogRef.componentInstance.translate = this.translate;
   }

   startOnedrive(type: any) {
      const onedrive = this.dialog.open(CreateOneDriveComponent, {
         disableClose: true,
         data: this
      });
      onedrive.componentInstance.doctype = type;
      onedrive.componentInstance.path = this.path;
      onedrive.componentInstance.isBusiness = true;
   }

   startGoogle(type: any) {
      const google = this.dialog.open(CreateGoogleDriveComponent, {
         disableClose: true,
         data: {
            businessComponent: this,
            path: this.path,
            type: type
         }
      });
      google.componentInstance.isBusiness = true;
   }

   onDragOver(event: DragEvent) {
      const data = event.dataTransfer;
      let hasFiles = false;
      if (data.items) {
         for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].kind === 'file') {
               hasFiles = true;
               break;
            }
         }
      } else if (data.files && data.files.length > 0) {
         hasFiles = data.files && data.files.length > 0;
      }

      if (hasFiles && !this.uploader.busy) {
         event.preventDefault();
         event.stopPropagation();
         event.dataTransfer.dropEffect = 'copy';
         this.renderer.addClass(this.docList.nativeElement, 'drag-over');
      }
   }

   onDrop(event: DragEvent) {
      event.preventDefault();
      event.stopPropagation();
      this.renderer.removeClass(this.docList.nativeElement, 'drag-over');
      this.uploader.process(event.dataTransfer, this.upload.limitSize, this.path, this.tin, this.uploadCallback);
   }

   onDragLeave() {
      this.renderer.removeClass(this.docList.nativeElement, 'drag-over');
   }

   uploadFolder(files: FileList): void {
      this.uploader.uploadFolder(files, this.upload.limitSize, this.path, this.tin, this.uploadCallback);
   }

   uploadNewVersion(event: any): void {
      this.annotationObj = event.annotationObj;
      this.uploader.uploadFolder(event.file, this.upload.limitSize, this.path, null, this.uploadCallback, event.item.id, null, event.isMajor);
   }

   uploadSelected(myFiles: any): void {
      this.uploader.uploadFolder(myFiles, this.upload.limitSize, this.path, this.tin, this.uploadCallback);
   }

   checkSelectItem() {
      this.permisionMove = true;
      this.permisionDel = true;
      this.permisionDup = true;
      if (this.selectedItems) {
         for (const itemSel of this.selectedItems) {
            if (!(itemSel.permissions.write && itemSel.permissions.delete)) {
               this.permisionMove = false;
            }

            if (!itemSel.permissions.delete) {
               this.permisionDel = false;
            }

            if(!(itemSel.permissions.write || itemSel.permissions.delete)){
               this.permisionDup = false;
            }

            if ((itemSel.startFlow && itemSel.statusDocument !== '') || itemSel.isFolder) {
               this.permisionDup = false;
            }

            if (itemSel.startFlow) {
               this.permisionDel = false;
            }

            if (this.isZdoxFile(itemSel)) {
               this.permisionDup = false;
            }
         }
      }
   }

   selectedDownload() {
      const listIds = [];
      let name = 'Archive';
      if (this.selectedItems) {
         if (this.selectedItems.length === 1) {
            name = this.selectedItems[0].name;
         }
         for (const itemSel of this.selectedItems) {
            listIds.push(itemSel.id);
         }
      }

      this.dialog.open(DownloadZipComponent, {
         disableClose: true,
         data: {
            idList: listIds,
            name: name,
            service: this.service
         }
      });
   }

   openSelectedMove() {
      this.movedialog = this.dialog.open(MoveDialogComponent, {
         disableClose: true,
         data: {
            service: this.service, listItem: this.selectedItems,
            isMultiSelect: true, data: this, toast: this.toast, translate: this.translate
         }
      });
      this.movedialog.afterClosed().subscribe(result => {
         if (result) {
            this.selectedItems = [];
         }
      });
   }

   duplicate(){
      const listIds = [];
      for(const itemId of this.selectedItems){
         if (this.selectedItems.length > 1) {
            if (!(itemId.startFlow && itemId.statusDocument !== '')) {
               listIds.push(itemId.id);
            }
         } else {
            listIds.push(itemId.id);
         }
      }
      this.service.duplicateDoc(listIds)
         .subscribe(data => {
            this.translate.get('alert.duplicate_complete').subscribe(s => {
               this.toast.success(s);
               this.docList.showdocument.emit();
               this.selectedItems = [];
            });
         });
   }

   confirmDelete(): void {
      const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
         disableClose: true,
         data: {
            service: this.service, listItem: this.selectedItems.sort((a: any, b: any) => a.name < b.name ? -1 : 1),
            isMultiSelect: true, data: this, toast: this.toast, translate: this.translate
         }
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            this.selectedItems = [];
         }
      });
   }

   onItemAllSelect(chk: any) {
      for (let i = 0; i < this.docList.items.length; i++) {
         this.docList.items[i].selected = chk.checked;
         const index = this.selectedItems.indexOf(this.docList.items[i]);
         if (this.docList.items[i].selected) {
            if (index === -1) {
               this.selectedItems.push(this.docList.items[i]);
            }
         } else {
            if (index !== -1) {
               this.selectedItems.splice(index, 1);
            }
         }
      }
   }

   settingSite = function () {
      this.service.getBusinessSiteBySiteCode(this.tin).subscribe(rs => {
         if (rs) {
            localStorage.setItem('tin', rs.tin)
            const url = Path.combine('/admin-tool/company-profile', encodeURIComponent(this.paths[0].name));
            localStorage.setItem('admin-tool', 'true');
            sessionStorage.setItem('siteCode', this.tin);
            this.router.navigate([url]);
         }
      })
   };

   openFormListDialog() : void {

      this.service.getBusinessSiteBySiteCode(this.tin).subscribe(rs => {
         if (rs) {
            localStorage.setItem('tin', rs.tin);
            localStorage.setItem('siteCode', rs.siteCode);
            this.formListDialog = this.dialog.open(FormListDialogComponent, {
               disableClose: true,
               data: this
            });
            this.formListDialog.componentInstance.path = this.path;
         }
      });
   }

   openPdfTemplateListDialog() : void {
      let path = location.pathname + location.search;
      const idex = '/idex';
      if (path.startsWith(idex)) {
         path = path.substring(idex.length);
      }
      localStorage.setItem('url', Path.combine(path));
      const pathStartFlow = this.paths.map((data) => data['name']).join('/');
      localStorage.setItem('paths', pathStartFlow);

      this.service.getBusinessSiteBySiteCode(this.tin).subscribe(rs => {
         if (rs) {
            localStorage.setItem('tin', rs.tin);
            localStorage.setItem('siteCode', rs.siteCode);
            this.pdfTemplateListDialog = this.dialog.open(PdfTemplateListDialogComponent, {
               disableClose: true,
               data: this
            });
            this.pdfTemplateListDialog.componentInstance.path = this.path;
         }
      });
   }

   share(items: any) {
      this.itemDocument.id = this.docList.dataFolder.parent.nodeRef.split('/')[3];
      this.itemDocument.item = items;
      this.docList.share(this.itemDocument);
   }

   isZdoxFile(item: any): boolean {
      if (item.isFolder) {
         return false;
      }
      let ext = item?.name?.split('.').pop();
      return ext.toLowerCase() === 'zdox';
   }
}
